/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dropwinnercount2Inputs */

const en_dropwinnercount2 = /** @type {(inputs: Dropwinnercount2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Winners`)
};

const de_dropwinnercount2 = /** @type {(inputs: Dropwinnercount2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gewinner`)
};

/**
* | output |
* | --- |
* | "Winners" |
*
* @param {Dropwinnercount2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const dropwinnercount2 = /** @type {((inputs?: Dropwinnercount2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dropwinnercount2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_dropwinnercount2(inputs)
	return de_dropwinnercount2(inputs)
});
export { dropwinnercount2 as "dropWinnerCount" }